<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-motivo')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-motivo')"></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
        <el-form-item :label="$t('codigo')" prop="code">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input ref="code" :disabled="id !== ''" v-model="ruleForm.code"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('descricao')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ativo')" prop="active">
          <el-switch v-model="ruleForm.active"></el-switch>
        </el-form-item>
        <div class="bottom clearfix">
          <el-form-item>
            <el-button
              type="warning"
              v-if="id === ''"
              autofocus
              @click="submitForm('ruleForm')"
            >{{ $t('adicionar') }}</el-button>
            <el-button
              type="warning"
              v-if="id !== ''"
              autofocus
              @click="editForm('ruleForm')"
            >{{ $t('atualizar') }}</el-button>
            <el-button type="danger" @click="back()">{{ $t('voltar') }}</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { ReasonService } from "@/services/customers/reason.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "PackingAdd",
  data() {
    return {
      id: "",
      ruleForm: {
        name: "",
        code: "",
        active: true,
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      this.$router.replace({ name: "reason" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ReasonService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.name;
          vm.ruleForm.code = response.code;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ReasonService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("motivo-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ReasonService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("motivo-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
